import type {
  CreateNodeRequest,
  DrainNodeResponse,
  ListAssignmentsQuery,
  ListNodesQuery,
  Node,
  NodePage,
  RebalanceResponse,
  ShardAssignmentPage,
  ShardResolveResponse,
  UpdateNodeRequest,
} from "@rema/shared/schemas/nodes"
import { api } from "../../lib/api"

// Capa de datos del módulo Nodos: llamadas tipadas al cliente fetch de la consola.
// Las rutas y formas son las de apps/api/src/routes/nodes.ts (docs/04 §2-§3).

export interface ReassignRequest {
  user_id: string
  node_id: string
}

export const nodesApi = {
  list: (query: Omit<ListNodesQuery, "cursor">, cursor: string | null) =>
    api.get<NodePage>("/admin/nodes", {
      query: {
        limit: query.limit,
        status: query.status,
        region: query.region,
        q: query.q,
        cursor: cursor ?? undefined,
      },
    }),

  create: (body: CreateNodeRequest) => api.post<Node>("/admin/nodes", body),

  update: (id: string, body: UpdateNodeRequest) => api.patch<Node>(`/admin/nodes/${id}`, body),

  remove: (id: string) => api.delete<undefined>(`/admin/nodes/${id}`),

  listAssignments: (query: Omit<ListAssignmentsQuery, "cursor">, cursor: string | null) =>
    api.get<ShardAssignmentPage>("/admin/shards/assignments", {
      query: { limit: query.limit, node_id: query.node_id, cursor: cursor ?? undefined },
    }),

  reassign: (body: ReassignRequest) =>
    api.post<ShardResolveResponse>("/admin/shards/assignments", body),

  // M4b · sharding dinámico.
  drain: (id: string, confirm: boolean) =>
    api.post<DrainNodeResponse>(`/admin/nodes/${id}/drain`, { confirm }),

  rebalance: (dryRun: boolean) =>
    api.post<RebalanceResponse>("/admin/shards/rebalance", { dry_run: dryRun }),
}
